import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import styles from "../BrandPage/BrandsPage.module.scss";

import BeautyandWellness from "../../../assets/images/Beauty&Wellness.png";
import AviationAndHospitality from "../../../assets/images/AviationAndHospitality.png";
import ItAndBanking from "../../../assets/images/ItAndBanking.png";
import AnimationVfx from "../../../assets/images/AnimationVfx.png";
import VirtualProduction from "../../../assets/images/VirtualProduction.png";
import PreschoolImg from "../../../assets/images/PreschoolImg.png";
import AptechAssessment from "../../../assets/images/AptechAssessment.png";
import trainingSolution from "../../../assets/images/trainingSolution.png";
import collaborationImage from "../../../assets/images/collaborationImage.png";

interface DataItem {
  title: string;
  description: string;
  logo: string;
}

const data: DataItem[] = [
  {
    title: "Beauty & Wellness",
    description: `Transforming future beauty and wellness professionals through practical training in areas like cosmetology, makeup, skin, and hair with our brand Lakmé Academy powered by Aptech`,
    logo: BeautyandWellness,
  },
  {
    title: "Aviation & Hospitality",
    description: `Preparing students for sky-high careers in aviation, travel, tourism, hospitality, and luxury retail with our brand Avalon Academy.`,
    logo: AviationAndHospitality,
  },
  {
    title: "IT & Banking",
    description:
      "Equipping learners with latest skills in IT, Banking, Finance, Hardware & Networking, and English Language with our brand Aptech Learning",
    logo: ItAndBanking,
  },
  {
    title: "Animation, VFX & Game Design",
    description:
      "Training future animation, VFX, and gaming professionals through Arena Animation and MAAC, covering 3D Animation, Game Design, AR VR, Multimedia and Digital Design courses.",
    logo: AnimationVfx,
  },
  {
    title: "Virtual production",
    description:
      "Offering comprehensive training in key virtual production skills through The Virtual Production Academy, a one-of-a-kind academy in Mumbai, India.",
    logo: VirtualProduction,
  },
  {
    title: "Preschool Education",
    description:
      "Providing a safe, secure, engaging, and stimulating learning environment for young minds through Aptech International Preschool.",
    logo: PreschoolImg,
  },
];

const institutionaldata: DataItem[] = [
  {
    title: "Aptech Assessment & Testing Solutions",
    description: `A comprehensive testing platform that provides online and offline assessments for universities, corporates, and autonomous bodies.`,
    logo: AptechAssessment,
  },
  {
    title: "Training Solutions",
    description: `Customized corporate training programs that are tailored for industry professionals to enhance their skills and productivity at the workplace`,
    logo: trainingSolution,
  },
  {
    title: "Educational Institutes & Corporates",
    description:
      "Providing strategic training programs to government and private education institutes, like schools & colleges, which are aligned with the rapidly changing demands of the education and corporate sectors.",
    logo: collaborationImage,
  },
];

const BrandsPage: React.FC = () => {
  const section1Ref = useRef<HTMLDivElement>(null);
  const section2Ref = useRef<HTMLDivElement>(null);
  const [visibleSections, setVisibleSections] = useState<{
    [key: string]: boolean;
  }>({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections((prev) => ({
              ...prev,
              [entry.target.id]: true,
            }));
          }
        });
      },
      { threshold: 0.1 }
    );

    if (section1Ref.current) observer.observe(section1Ref.current);
    if (section2Ref.current) observer.observe(section2Ref.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div id="BrandsPage" className={styles.BrandsPage}>
      <div className="container">
        {/* First Section */}
        <motion.div
          id="section1"
          ref={section1Ref}
          initial={{ opacity: 0, y: 100 }}
          animate={visibleSections["section1"] ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1, ease: "easeInOut" }}
        >
          <div className="subSection">
            <div className="row">
              <div className="col-12">
                <p className={`cardHeading caps text-center ${styles.domesticTitle}`}>
                  <strong>Domestic Retail</strong>
                </p>
              </div>
            </div>
            <div className="row g-4">
              {data.map((item, index) => (
                <div
                  key={index}
                  className="col-lg-4 col-md-6 col-sm-12 d-flex position-relative"
                >
                  <div className={`${styles.customCard} flex-fill`}>
                    <div
                      className={`${styles.contentCard} d-flex flex-column justify-content-between`}
                    >
                      <div
                        className={`${styles.outerContent} d-flex flex-column align-items-start`}
                      >
                        <div className="w-100">
                          <div className="">
                            <img
                              src={item.logo}
                              alt="Aptech Logo"
                              className={`${styles.logo}`}
                            />
                          </div>
                        </div>
                        <div>
                          <h6 className={`heading3 ${styles.contentTitle}`}>
                            <strong className="caps">{item.title}</strong>
                          </h6>
                        </div>
                        <div>
                        <p
  className={`para2 ${styles.contentDescription}`}
  style={{
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  }}
  dangerouslySetInnerHTML={{
    __html: item.description,
  }}
></p>

<p className={`para2 pt-2 ${styles.readMore}`}> <a href="/our-businesses/invidual"><strong>Read More</strong></a></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </motion.div>

        {/* Second Section */}
        <motion.div
          id="section2"
          ref={section2Ref}
          initial={{ opacity: 0, y: 100 }}
          animate={visibleSections["section2"] ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1, ease: "easeInOut" }}
        >
          <div className="subSection">
          <p className={`cardHeading caps text-center ${styles.institutionalTitle} mb-1`}>
                  <strong>Institutional Business (EBG)</strong></p>
                  <div className="d-flex justify-content-center align-items-center">
            <p className={`para mb-4 text-center ${styles.institutionalPara}`}>
            Aptech’s Enterprise Business Group (EBG) delivers assessment and corporate training solutions to organizations, government bodies, private sectors, and educational institutions.
            </p>
            </div>
            <div className="row g-4 justify-content-center">
              {institutionaldata.map((item, index) => (
                <div
                  key={index}
                  className="col-lg-4 col-md-6 col-sm-12 d-flex position-relative"
                >
                  <div className={`${styles.customCard} flex-fill`}>
                    <div
                      className={`${styles.contentCard} d-flex flex-column justify-content-between`}
                    >
                      <div
                        className={`${styles.outerContent} d-flex flex-column align-items-start`}
                      >
                        <div className="w-100">
                          <div className="">
                            <img
                              src={item.logo}
                              alt="Aptech Logo"
                              className={`${styles.logo}`}
                            />
                          </div>
                        </div>
                        <div>
                          <h6 className={`heading3 ${styles.contentTitle}`}>
                            <strong className="caps">{item.title}</strong>
                          </h6>
                        </div>
                        <div>
                        <p
  className={`para2 ${styles.contentDescription}`}
  style={{
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
  }}
  dangerouslySetInnerHTML={{
    __html: item.description,
  }}
></p>
<p className={`para2 pt-2 ${styles.readMore}`}> <a href="our-businesses/institutional-business"><strong>Read More</strong></a></p>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default BrandsPage;
